module.exports = __webpack_public_path__ + "static/media/akanksha_mahajan.b73668d4.jpg";